export default __webpack_public_path__ + "static/media/Sign.ccf2e3d3.png";